import moment from "moment-timezone";
import {ECOACH, IELTS} from "@/core/config/center/centerOption";

/** Khóa nội bộ để lọc / so sánh trạng thái thanh toán */
export const RETEST_PAYMENT_FILTER = Object.freeze({
    PAID: "paid",
    UNPAID: "unpaid",
    SHORTAGE: "shortage",
    FREE: "free",
});

export class RetestModel {
  constructor(record) {
    this.id = record.id;
    this.type = record.type;
    this.studentId = record.user?.id ? record.user?.id + 100000 : null;
    this.name = record.user?.name ?? "";
    this.courseName = record.course?.name ?? "";
    this.classCode = record?.classroom?.name ?? "";
    this.dateTest = this.formatDate(record?.markingExamSchedule?.exam_date);
    this.timeTest = this.formatTime(record?.markingExamSchedule?.start_time, record?.markingExamSchedule?.end_time);
    this.skillRetest = this.getSkillTest(record.skills);
    this.retestNumber = record.retest_count ?? "";
    this.result = this.resultString(record.result);
    this.showEditOrDelete = this.checkShowAction(record?.markingExamSchedule?.exam_date, record?.markingExamSchedule?.start_time);
    this.showDetail = this.checkViewResult(record.result);
    this.data = { ...record };
    this.is_fraud = record.is_fraud;
    this.uuid = record.uuid;
    this.centerName = record.center_name;
    this.creatorName = record.creator?.name ?? "N/A";
    this.branchName = record.classroom?.branch?.name ?? "";

      const paymentCat = RetestModel.resolvePaymentCategory(record);
      this.paymentCategory = paymentCat;
      this.paymentStatusLabel = RetestModel.paymentCategoryLabel(paymentCat);
      this.paymentStatusClass = RetestModel.paymentCategoryClass(paymentCat);
      this.examCodeDisplay = RetestModel.resolveExamCodeDisplay(record, paymentCat);
      this.isActive = record.is_active;
      this.showDeleteSchedule =
          paymentCat === RETEST_PAYMENT_FILTER.UNPAID && this.showEditOrDelete;
      this.showPaymentGuideButton = RetestModel.canOpenPaymentGuide(record, paymentCat);
      this.showFixPaymentButton = paymentCat !== RETEST_PAYMENT_FILTER.FREE && paymentCat !== RETEST_PAYMENT_FILTER.PAID;
  }

    /**
     * paid_at / payment_status; retest_fee_type === 0 => không mất phí; 3 => thiếu tiền (theo convention phổ biến).
     */
    static resolvePaymentCategory(record) {
        const ps = record.payment_status;
        const paidAt = record.paid_at;
        const feeType = record.retest_fee_type ?? record.payment_fee_type;
        const amount = record.payment?.payment_amount ?? record.payment_amount;

        if (feeType === 0 || record.is_free_retest === true || record.waive_fee === true) {
            return RETEST_PAYMENT_FILTER.FREE;
        }
        if (paidAt || ps === 1 || ps === "1") {
            return RETEST_PAYMENT_FILTER.PAID;
        }
        if (ps === 3 || ps === "3") {
            return RETEST_PAYMENT_FILTER.SHORTAGE;
        }
        if (ps === 0 || ps === "0" || ps === null || ps === undefined) {
            return RETEST_PAYMENT_FILTER.UNPAID;
        }
        if (amount > 0 && !paidAt) {
            return RETEST_PAYMENT_FILTER.UNPAID;
        }
        return RETEST_PAYMENT_FILTER.UNPAID;
    }

    static paymentCategoryLabel(cat) {
        switch (cat) {
            case RETEST_PAYMENT_FILTER.PAID:
                return "Đã thanh toán";
            case RETEST_PAYMENT_FILTER.SHORTAGE:
                return "Thiếu tiền";
            case RETEST_PAYMENT_FILTER.FREE:
                return "Không mất phí";
            default:
                return "Chưa thanh toán";
        }
    }

    static paymentCategoryClass(cat) {
        switch (cat) {
            case RETEST_PAYMENT_FILTER.PAID:
                return "pay-paid";
            case RETEST_PAYMENT_FILTER.SHORTAGE:
                return "pay-shortage";
            case RETEST_PAYMENT_FILTER.FREE:
                return "pay-free";
            default:
                return "pay-unpaid";
        }
    }

    /**
     * Mã dự thi: exam_code. Nếu đã thanh toán nhưng full slot và chưa có mã → nhắc đổi lịch.
     */
    static resolveExamCodeDisplay(record, paymentCat) {
        const code =
            record.exam_code ??
            record.exam_registration_code ??
            record.registration_code ??
            record.shift_name ??
            "";
        const paid = paymentCat === RETEST_PAYMENT_FILTER.PAID;
        const slotFull =
            record.shift_is_full === true ||
            record.is_shift_full === true ||
            record.slot_full === true ||
            record.marking_exam_shift_full === true ||
            record.markingExamSchedule?.is_full === true ||
            record.markingExamSchedule?.shift_full === true;

        if (paid && slotFull && !String(code).trim()) {
            return "Chưa có - Vui lòng đổi lịch";
        }
        if (String(code).trim()) {
            return String(code).trim();
        }
        return "—";
    }

    static canOpenPaymentGuide(record, paymentCat) {
        if (paymentCat === RETEST_PAYMENT_FILTER.FREE || paymentCat === RETEST_PAYMENT_FILTER.PAID) {
            return false;
        }
        const opt = record.payment?.option_type ?? record.payment_option_type;
        const p = record.payment;
        const hasBank = p && (p.bank_name || p.bank_account_number);
        if (opt === 3) return true;
        if (hasBank && (paymentCat === RETEST_PAYMENT_FILTER.UNPAID || paymentCat === RETEST_PAYMENT_FILTER.SHORTAGE)) {
            return true;
        }
        return (
            record.payment_method === "transfer"
        );
  }

  getSkillTest(value) {
    if (value && value.length > 0) {
      return value.map((item) => item.name).join(", ");
    }
    return "";
  }

  formatDate(value) {
    if (value) {
      return moment(value).format("DD-MM-YYYY");
    }
    return "";
  }

  formatTime(start, end) {
    if (start && end) {
      return `${start} - ${end}`;
    }
    return "";
  }

  resultString(value) {
    switch (value) {
      case 0:
        return "Fail";
      case 1:
        return "Pass";
      default:
        return "";
    }
  }

  checkViewResult(result) {
    return result != null;
  }

  checkShowAction(examDate, timeStart) {
    if (examDate && timeStart) {
      const date = moment(examDate).format("DD-MM-YYYY");
      const [day, month, year] = date.split("-").map(Number);
      const [hour, minute, second] = timeStart.split(":").map(Number);
      const examDateTime = new Date(year, month - 1, day, hour, minute, second);
      const oneDayBeforeExam = new Date(examDateTime);
      oneDayBeforeExam.setDate(oneDayBeforeExam.getDate() - 1);
      const now = new Date();
      return now < oneDayBeforeExam;
    }
      return false;
  }
}

export class PointDetailModel {
  constructor(record) {
    this.id = record.id;
    this.testNumber = record.retest_count;
    this.speaking = record.speaking_score;
    this.listening = record.listening_score;
    this.reading = record.reading_score;
    this.written = record.writing_score;
    this.vocabulary = record.vocab_score;
    this.overall = record.overall_score;
    this.updatedAt = this.formatDate(record.updated_at);
    this.userUpdated = record.updated_by;
  }

  formatDate(value) {
    if (value) {
      return moment(value).format("DD-MM-YYYY hh:mm:ss");
    }
    return "";
  }
}
